/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DlsgPolicy } from '../models/DlsgPolicy';

export class GetDlsgPolicyResponse {
  'dlsgPolicy': DlsgPolicy | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "dlsgPolicy",
      "baseName": "dlsgPolicy",
      "type": "DlsgPolicy",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetDlsgPolicyResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

